import Reflux from "reflux";

import Chip from "@javascript/reactComponents/lds/chips/Chip";
import FacetSearchStore from "@javascript/stores/facetSearchStore";
import { FacetSearchCompanyActivityActions } from "@javascript/stores/actions/facetSearch/activityActions";

import { COMPANY_ACTIVITY_CATEGORY_TO_LABEL } from "@javascript/constants/search/search_constants";


const FacetSearchCriteriaCategory = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function(data) { return data.activities })
  ],
  getInitialState() {
    return {
      ...(FacetSearchStore.data.activities),
      locked: this.isLocked(FacetSearchStore.data.activities.selected)
    }
  },

  isLocked(currentCat = this.state?.selected) {
    const original = Zymewire.original_feed_query;

    return (
      original &&
      original.category &&
      original.category !== "all_event" &&
      original.category === currentCat
    );
  },
  removeCategory() {
    if (this.state.locked) return;
    FacetSearchCompanyActivityActions.activityRemoved();
  },
  render() {
    let category

    const currentCat = this.state.selected

    if (currentCat !== 'all_event') {
      category = Zymewire.category_hash[currentCat]
    }

    if (category === null || category === undefined) return null;

    if (this.state.locked) {
      category["locked"] = true;
    }

    let trailingIcon = "cancel";

    const label = `${Zymewire.facet_search_filters.company_activity}: ${category.name}`

    const activity = COMPANY_ACTIVITY_CATEGORY_TO_LABEL[category.category] || COMPANY_ACTIVITY_CATEGORY_TO_LABEL[category.parent] || "other";

    return (
      <Chip
        className={`search_filter_applied_chip_activity_${activity}`}
        label={label}
        leadingIcon="activity"
        size="small"
        {...!this.state.locked && {
          trailingIcon: trailingIcon,
          trailingIconClassName: "search_filter_applied_trailing_icon",
          trailingIconOnClick: this.removeCategory,
        }}
        variant="secondary"
      />
    );
  }
});

window.FacetSearchCriteriaCategory = FacetSearchCriteriaCategory;
export default FacetSearchCriteriaCategory;
